<template>
    <div id="cart-wrapper" :class="{'cart-loading' : cart.loading}">
        
        <div class="basket-cart-content">
            <div class="basket-table">
                <div class="updatecart">
                    <div class="basket-row-header">
                        <span class="cart-title"><translate item="CartTitle" /></span>
                        <input type="checkbox" class="d-none" name="removeallfromcart" value="all" />
                        <span><button v-if="cart.model.totalItems > 0" v-on:click="empyBasket" class="btn cart-remove-all float-right"><span><translate item="CartEmptyBasket" /></span><span class="icon-trash removefromcart" title="Verwijder"></span></button></span>
                        <basket-count :totalItems="cart.model.totalItems"></basket-count>
                        <button class="btn-close-default" type="button" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle cart"><span class="icon icon-close"></span></button>
                    </div>

                    <div class="card added-products">
                        <!-- cart-items, dont change the ID of this container, clientscript depends on it. -->
                        <div class="cart-items cart-body" id="cart-items">
                            <div v-if="!items.length" class="empty-basket text-center">
                                <div class="col-12"></div> <!-- image container -->
                                <span><translate item="CartEmpty" /></span>
                            </div>

                            <div v-if="isVisible">
                                <amz-cart-rewardpoints v-bind:cart="cart" v-if="cart.model.displayRewardPoints"></amz-cart-rewardpoints>
                                <amz-cart-item v-on:remove-cart-item="removeCartItem(item, $event)" v-on:cart-item-quantitychanged="quantitychanged(item, $event)" v-for="(item, index) in items" v-bind:item="item" v-bind:key="item.id"></amz-cart-item>
                                <div class="card calculations card-body ">
                                    <div class="col-12"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cart-basket-bottom">

                        <div class="rewardpoints-to-earn" v-if="cart.model.willEarnRewardPoints > 0">
                            <span class="caption">
                                <translate item="YouEarnRewardpoints" fallback="Je verdient" />
                            </span>
                            <span class="price">
                                <span class="in">
                                    {{cart.model.willEarnRewardPoints}} <translate v-if="cart.model.willEarnRewardPoints>1" item="RewardPoints" fallback="punten" /><translate v-if="cart.model.willEarnRewardPoints == 1" item="RewardPoint" fallback="punt" />
                                </span>
                            </span>
                        </div>

                        <div class="card deliverymethods card-body" :class="{hideMethods:hideMethods }">
                            <delivery-methods v-if="showDeliveryMethods" :getshippingroute="getshippingroute"></delivery-methods>
                        </div>

                        <slot></slot>
                        <div class="cart-totalsummary " v-if="showSubTotals">

                            <div class="subtotal">
                                <span class="caption">
                                    <translate item="SubTotal" fallback="Subtotaal" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{cart.model.subTotal.priceInclTax | toCurrency}}
                                    </span>
                                </span>
                            </div>

                            <div class="cart-subtotal-items subTotalDiscount" v-if="cart.model.subTotalDiscount.priceInclTax > 0">
                                <span class="caption">
                                    <translate item="DiscountAmount" fallback="Korting" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{-cart.model.subTotalDiscount.priceInclTax | toCurrency}}
                                    </span>
                                </span>
                            </div>


                            <div class="cart-subtotal-items shippingcost" v-if="cart.model.estimateShipping.shippingRate.priceInclTax > 0">
                                <span class="caption">
                                    <translate item="ShippingCosts" fallback="Bezorgkosten" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{cart.model.estimateShipping.shippingRate.priceInclTax | toCurrency}}
                                    </span>
                                </span>
                            </div>

                            <div class="cart-compositetotal taxamount" v-if="cart.model.compositeTotal.priceInclTax>0">
                                <span class="caption"><translate item="InclComposite" fallback="Inclusief statiegeld" /></span>
                                <span class="price">{{cart.model.compositeTotal.priceInclTax | toCurrency}}</span>
                            </div>
                            <div class="cart-subtotal-items">
                                <span class="caption">
                                    <translate item="TaxAmount" fallback="inclusief btw" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{cart.model.total.taxPrice | toCurrency}}
                                    </span>
                                </span>
                            </div>

                            <div class="cart-subtotal-items discountamount" v-if="cart.model.discountTotal > 0">
                                <span class="caption">
                                    <translate item="DiscountAmount" fallback="Korting" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{-cart.model.discountTotal | toCurrency}}
                                    </span>
                                </span>
                            </div>

                            <div class="cart-subtotal-items applieddiscounts" v-if="cart.model.appliedDiscounts.length > 0">
                                <span class="caption">
                                    <translate item="AppliedDiscounts" fallback="Jouw korting" />
                                </span>
                                <span class="cart-discount-list">
                                    <span class="in">
                                        <span class="badge badge-success" v-for="discountName in cart.model.appliedDiscounts">
                                            {{discountName}}
                                        </span>
                                    </span>
                                </span>
                                <span class="price">

                                    <span class="in" v-if="cart.model.rewardPointsRedemptionMethod != 'ordertotal'">
                                        {{(cart.model.discountTotal + cart.model.redeemedRewardPointsAmount) | toCurrency}}
                                    </span>

                                    <span class="in" v-if="cart.model.rewardPointsRedemptionMethod == 'ordertotal'">
                                        {{(cart.model.discountTotal) | toCurrency}}
                                    </span>

                                </span>
                            </div>

                            <div class="cart-subtotal-items applieddiscounts" v-if="cart.model.rewardPointsRedemptionMethod == 'ordertotal' && cart.model.redeemedRewardPointsAmount > 0">
                                <span class="caption">
                                    <translate item="RedeemedRewardPointsAmount" fallback="Ingewisselde punten" />
                                </span>
                                <span class="price">
                                    <span class="in">
                                        {{(-cart.model.redeemedRewardPointsAmount) | toCurrency}}
                                    </span>
                                </span>
                            </div>



                        </div>


                        <div class="card checkout card-body" :class="{inCheckout:inCheckout }">
                            <div class="cart-bar-checkout">

                                <div v-if="!inCheckout">
                                    <a v-bind:href="checkoutLink" class="btn btn-default btn-place-order-total btn-close-handler" v-bind:class="{ 'btn-place-order-total-empty-cart' : !items.length || cart.continueButtonDisabled }">
                                        <span class="caption">
                                            <translate item="CartCheckoutLinkCaption" />
                                        </span>
                                        <span class="cart-button-price-field"><span class="in">{{cart.model.total.priceInclTax | toCurrency}}</span></span>
                                    </a>
                                </div>

                                <div class="btn-close-handler mdcustom-show" v-if="inCheckout">
                                    <div class="btn btn-default btn-place-order-total">
                                        <span class="caption"><translate item="CartTotalCaption" /></span>
                                        <span class="cart-button-price-field">
                                            <span class="in">
                                                {{cart.model.total.priceInclTax | toCurrency}}
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <div class="btn-close-handler mdcustom-hide" v-if="inCheckout">
                                    <div class="btn btn-default btn-place-order-total">
                                        <span class="caption"><translate item="CartPlaceOrderCaption" /></span>
                                        <span class="cart-button-price-field">
                                            <span class="in">
                                                {{cart.model.total.priceInclTax | toCurrency}}

                                            </span>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { services, EventBus } from '../Services/Services'
    import shoppingCartService from '../Services/ShopingCartService';
    import amzCartItem from './amz-cart-item.vue';
    import amzCartRewardpoints from './amz-cart-rewardpoints.vue';
    import deliveryMethods from './delivery-methods.vue';
    import basketCount from './basket-count.vue'
    import translate from './translate';
    import translateService from '../Services/TranslateService';

    export default {
        data: function () {
            // return the shoppingcart model defined in services.js
            return { cart: shoppingCartService.shoppingCart, isVisible: false, checkoutLink: shoppingCartService.checkoutLink };
        },

        props: {
            getshippingroute: String,
            /**
             * A value indicating whether we are in the checkout steps or not
             **/
            inCheckout: Boolean,
            hideMethods: Boolean
        },

        components: { amzCartItem, deliveryMethods, basketCount, translate, translateService, amzCartRewardpoints },

        methods: {
            /**
             * Click handler for the empty basket button
             * */
            empyBasket: function () {
                // ask the user
                if (cartConfirmRemove()) {
                    this.loading = true;
                    shoppingCartService.emptyBasket();
                }

                // cart ask for confirmation on removing product ()
                function cartConfirmRemove() {
                    return confirm(translateService.TranslationsDictionary['Vue.AlertEmptyCart']);
                }
            },

            /**
             * Handler for the cart remove item button
             * @param {object} event - the event with the element beeing clicked
             */
            removeCartItem: function (item) {
                this.loading = true;
                shoppingCartService.removeCartItem(item);
            },

            /**
             * Handler for the cart remove item button
             * @param {object} event - the event with the element beeing clicked
             */
            quantitychanged: function (item, $event) {
                this.loading = true;
                shoppingCartService.quantitychanged(item, $event.oldQ);
            }
        },

        computed: {
            // the shopping bag items
            items: function () {
                // filter ? not needed yet
                return shoppingCartService.shoppingCart.model.items.filter(a => {
                    return !a.removed;
                }).slice().reverse();
            },

            // Show the delivery methods, only when the items are not removed and the item is not pending
            // delivery methods can onlybe retreived from server when the shopping bag is synced to the server (not pending)
            showDeliveryMethods: function () {
                for (var key in shoppingCartService.shoppingCart.model.items) {
                    let item = shoppingCartService.shoppingCart.model.items[key];
                    if (!item.removed && !item.pending) {
                        return true;
                    }
                }
                return false;
            },
            showSubTotals: function () {
                return this.cart.model.appliedDiscounts.length > 0
                    || this.cart.model.compositeTotal.priceInclTax > 0
                    || this.cart.model.estimateShipping.shippingRate.priceInclTax > 0
                    || this.cart.model.discountTotal > 0
                    || this.cart.model.appliedDiscounts.length > 0
                    || this.cart.model.willEarnRewardPoints > 0
                    || this.cart.model.subTotalDiscount.priceInclTax > 0;
            }
        },

        mounted: function () {
            var vm = this;

            /**
             Global reload cart handler, used in init (below), and when the shipping-methods change
             */
            EventBus.$on('reload-cart', function () {
                // make sure we load the allergies first, the rendering of the cart depends on them
                services.getAllergies(function () {
                    vm.isVisible = true;
                    shoppingCartService.loadShoppingCart();
                });
            });

            //init
            EventBus.$emit('reload-cart', null);

            $(Amazilia).on('reload-cart', function () {
                EventBus.$emit('reload-cart', null);
            });

        },

        updated: function () {
            this.$nextTick(function () {
                $('.col-cart').getNiceScroll().resize();
                $('#cart-wrapper #cart-items').getNiceScroll().resize();
            })
        }
    }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-cart.vue